module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [(_vm.commercials.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "公司名称",
      "prop": "commercial_id"
    }
  }, [(_vm.commercials.length > 1) ? _c('el-select', {
    attrs: {
      "placeholder": "全部"
    },
    on: {
      "change": function($event) {
        return _vm.getShopList()
      }
    },
    model: {
      value: (_vm.queryForm.commercial_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "commercial_id", $$v)
      },
      expression: "queryForm.commercial_id"
    }
  }, _vm._l((_vm.commercials), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.commercials.length == 1) ? _c('el-input', {
    attrs: {
      "type": "text",
      "value": _vm.commercials[0].name,
      "disabled": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.shops.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteShopMethod,
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shop_id", $$v)
      },
      expression: "queryForm.shop_id"
    }
  }, _vm._l((_vm.shopList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.queryForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v)
      },
      expression: "queryForm.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-card', {
    staticClass: "box-card mb20",
    staticStyle: {
      "background-color": "#eaf5fc"
    }
  }, [_c('el-row', [(_vm.$store.getters.type == 1) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_vm._v("\n                    总收款流水\n                    "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "总收款流水＝校方收款流水+公司收款流水",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_vm._v("＋"), _c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.summary.totalBillAmount || 0))]), _vm._v("元")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("实际" + _vm._s(_vm.summary.totalOrderSum) + "单 补打款" + _vm._s(_vm.summary.totalDebtOrderSum) + "单")])]) : _vm._e(), _vm._v(" "), (_vm.$store.getters.type == 1) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_vm._v("\n                    校方收款流水\n                    "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "校方收款流水：账款直接打入学校账号",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_vm._v("＋"), _c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.summary.schoolBillAmount || 0))]), _vm._v("元")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("实际" + _vm._s(_vm.summary.schoolOrderSum) + "单 补打款" + _vm._s(_vm.summary.schoolDebtOrderSum) + "单")])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', [_vm._v("\n                    公司收款流水\n                    "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "户收款流水：账款打入公司账号",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  })])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "red f12"
  }, [_vm._v("＋"), _c('span', {
    staticClass: "f20 plr2"
  }, [_vm._v(_vm._s(_vm.summary.commercialBillAmount || 0))]), _vm._v("元")]), _vm._v(" "), _c('p', {
    staticClass: "c6"
  }, [_vm._v("实际" + _vm._s(_vm.summary.commercialOrderSum) + "单 补打款" + _vm._s(_vm.summary.commercialDebtOrderSum) + "单")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('export-excel', {
    attrs: {
      "params": _vm.exportParams,
      "action": _vm.$apiUrl.financeShopBill,
      "target": 'finance',
      "field": _vm.field,
      "filename": _vm.fileName,
      "fieldname": _vm.fieldName
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "序号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "businessDate",
      "label": "日期",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$utils.formatDate1(scope.row.businessDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "shopName",
      "label": "店铺名称",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "commercialName",
      "label": "公司名称",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill",
      "label": "账单类型",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "billAmount",
      "label": "收入金额（元）",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderSum",
      "label": "订单数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expenseAmount",
      "label": "退款金额（元）",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expenseSum",
      "label": "退款订单数",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realIncomeAmount",
      "label": "收入金额（剔除退款）",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realOrderSum",
      "label": "订单数（剔除退款）",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkoutType",
      "label": "收款方式",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.checkoutType == 1) ? _c('span', [_vm._v("学校")]) : _vm._e(), _vm._v(" "), (scope.row.checkoutType == 2) ? _c('span', [_vm._v("公司")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payType",
      "label": "打款方式",
      "show-overflow-tooltip": true,
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payType == 0) ? _c('span', [_vm._v("财务打款")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 1) ? _c('span', [_vm._v("财务打款")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 2) ? _c('span', [_vm._v("支付宝")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 3) ? _c('span', [_vm._v("银联转账")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 4) ? _c('span', [_vm._v("钱包提现")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 5) ? _c('span', [_vm._v("支付宝直付通打款")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 6) ? _c('span', [_vm._v("快钱分账")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "fixed": "right",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.view(scope.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "layout": "sizes, prev, next",
      "prev-text": "上一页",
      "next-text": "下一页"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77947634"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/finance/shop.vue
// module id = 924
// module chunks = 0